import React from 'react'

const Box = React.forwardRef(
  ({ children, component = 'div', sx = {}, className = '', ...props }, ref) => {
    // Convert MUI sx props to CSS styles
    const convertSxToStyles = (sxObj) => {
      const styles = {}

      if (sxObj) {
        Object.keys(sxObj).forEach((key) => {
          const value = sxObj[key]

          // Handle common MUI sx properties
          switch (key) {
            case 'display':
              styles.display = value
              break
            case 'flexDirection':
              styles.flexDirection = value
              break
            case 'justifyContent':
              styles.justifyContent = value
              break
            case 'alignItems':
              styles.alignItems = value
              break
            case 'gap':
              styles.gap = typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'p':
              styles.padding =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'px':
              styles.paddingLeft =
                typeof value === 'number' ? `${value * 8}px` : value
              styles.paddingRight =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'py':
              styles.paddingTop =
                typeof value === 'number' ? `${value * 8}px` : value
              styles.paddingBottom =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'pl':
              styles.paddingLeft =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'pr':
              styles.paddingRight =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'pt':
              styles.paddingTop =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'pb':
              styles.paddingBottom =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'm':
              styles.margin =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'mx':
              styles.marginLeft =
                typeof value === 'number' ? `${value * 8}px` : value
              styles.marginRight =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'my':
              styles.marginTop =
                typeof value === 'number' ? `${value * 8}px` : value
              styles.marginBottom =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'ml':
              styles.marginLeft =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'mr':
              styles.marginRight =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'mt':
              styles.marginTop =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'mb':
              styles.marginBottom =
                typeof value === 'number' ? `${value * 8}px` : value
              break
            case 'width':
              styles.width = value
              break
            case 'height':
              styles.height = value
              break
            case 'minWidth':
              styles.minWidth = value
              break
            case 'maxWidth':
              styles.maxWidth = value
              break
            case 'minHeight':
              styles.minHeight = value
              break
            case 'maxHeight':
              styles.maxHeight = value
              break
            case 'position':
              styles.position = value
              break
            case 'top':
              styles.top = value
              break
            case 'right':
              styles.right = value
              break
            case 'bottom':
              styles.bottom = value
              break
            case 'left':
              styles.left = value
              break
            case 'zIndex':
              styles.zIndex = value
              break
            case 'overflow':
              styles.overflow = value
              break
            case 'overflowX':
              styles.overflowX = value
              break
            case 'overflowY':
              styles.overflowY = value
              break
            case 'background':
              styles.background = value
              break
            case 'backgroundColor':
              styles.backgroundColor = value
              break
            case 'color':
              styles.color = value
              break
            case 'border':
              styles.border = value
              break
            case 'borderRadius':
              styles.borderRadius = value
              break
            case 'boxShadow':
              styles.boxShadow = value
              break
            case 'cursor':
              styles.cursor = value
              break
            case 'textAlign':
              styles.textAlign = value
              break
            case 'fontSize':
              styles.fontSize = value
              break
            case 'fontWeight':
              styles.fontWeight = value
              break
            case 'lineHeight':
              styles.lineHeight = value
              break
            case 'textDecoration':
              styles.textDecoration = value
              break
            case 'flex':
              styles.flex = value
              break
            case 'flexGrow':
              styles.flexGrow = value
              break
            case 'flexShrink':
              styles.flexShrink = value
              break
            case 'flexBasis':
              styles.flexBasis = value
              break
            case 'order':
              styles.order = value
              break
            case 'alignSelf':
              styles.alignSelf = value
              break
            case 'justifySelf':
              styles.justifySelf = value
              break
            case 'gridArea':
              styles.gridArea = value
              break
            case 'gridColumn':
              styles.gridColumn = value
              break
            case 'gridRow':
              styles.gridRow = value
              break
            case 'opacity':
              styles.opacity = value
              break
            case 'transform':
              styles.transform = value
              break
            case 'transition':
              styles.transition = value
              break
            case 'visibility':
              styles.visibility = value
              break
            default:
              // Handle custom CSS properties
              if (typeof value === 'string' || typeof value === 'number') {
                styles[key] = value
              }
          }
        })
      }

      return styles
    }

    const styles = convertSxToStyles(sx)

    const Component = component

    return (
      <Component ref={ref} className={className} style={styles} {...props}>
        {children}
      </Component>
    )
  }
)

Box.displayName = 'Box'

export default Box
